<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">Payment Method</h4>

  <button
    data-dd-action-name="add-payment-method-modal.close-button"
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="close()"
  ></button>
</div>
<form [formGroup]="form" (validSubmit)="onSubmit($event)">
  @if (loading) {
    <app-loading></app-loading>
  }

  @if (!loading) {
    <div class="modal-body">
      <p>Enter your payment details.</p>

      <app-payment
        [activeOrganisation]="activeOrganisation"
        [form]="form"
        parentComponent="modal"
        (failedToAttach)="paymentFailedToAttach()"
        (successfullyAttached)="paymentSaved()"
      ></app-payment>
    </div>

    <div class="modal-footer">
      <button
        data-dd-action-name="add-payment-method-modal.subscribe-button"
        type="submit"
        class="btn btn-primary"
        [disabled]="submitting"
      >
        <i-lucide name="play"></i-lucide>
        @if (newOrganisation) {
          Start Subscription
        }
        @if (!newOrganisation) {
          Upgrade Subscription
        }
      </button>
    </div>
  }
</form>
